/* Vivalle — direct browser Meta Pixel. No CAPI, no Shopify custom-pixel iframe.
   Controlled in Shopify Theme Editor > Home page > Vivalle Conversion V2.
   Conversion = confirmed creation of a COD order, not payment/delivery. */
(function () {
  'use strict';

  const element = document.currentScript ||
    document.querySelector('script[data-vivalle-meta-pixel]');
  const pixelId = String(element?.dataset?.vivalleMetaPixel || '').trim();
  if (!/^\d{8,20}$/.test(pixelId)) return;

  // Prevent duplicates if a Shopify Theme Editor preview re-renders the section.
  const stateKey = '__vivalleMetaControlled_' + pixelId;
  if (window[stateKey]) return;

  const state = window[stateKey] = {
    initialized: false,
    sentOrderIds: new Set()
  };

  function consentAllowed() {
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy || typeof privacy.marketingAllowed !== 'function') return false;
    try { return Boolean(privacy.marketingAllowed()); }
    catch (_) { return false; }
  }

  function initialize() {
    if (state.initialized || !consentAllowed()) return false;

    if (typeof window.fbq !== 'function') {
      !function(f,b,e,v,n,t,s){
        if(f.fbq)return;
        n=f.fbq=function(){
          n.callMethod ? n.callMethod.apply(n,arguments) :
          n.queue.push(arguments);
        };
        if(!f._fbq)f._fbq=n;
        n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];
        t=b.createElement(e);t.async=!0;t.src=v;
        s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s);
      }(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
    }

    window.fbq('init', pixelId);
    state.initialized = true;
    window.fbq('track', 'PageView');
    return true;
  }

  document.addEventListener('vivalle:order-confirmed', function (event) {
    const data = event?.detail || {};
    const value = Number(data.value);
    const orderId = String(data.event_id || '').trim();
    if (!orderId || !Number.isFinite(value) || value <= 0) return;
    if (state.sentOrderIds.has(orderId)) return;
    if (!consentAllowed()) return;
    if (!state.initialized && !initialize()) return;

    try {
      window.fbq('track', 'Purchase', {
        value: value,
        currency: 'MAD',
        content_name: String(data.content_name || 'Vivalle'),
        content_type: 'product'
      }, { eventID: orderId });
      state.sentOrderIds.add(orderId);
    } catch (err) {
      console.error('[Vivalle Meta] Purchase could not be queued:', err);
    }
  });

  document.addEventListener('visitorConsentCollected', initialize);
  if (window.Shopify?.customerPrivacy) {
    initialize();
  } else if (typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) { if (!error) initialize(); }
    );
  } else {
    window.addEventListener('load', initialize, { once: true });
  }
})();